import { render, staticRenderFns } from "./ahis.vue?vue&type=template&id=bf2e99a6"
import script from "./ahis.vue?vue&type=script&lang=js"
export * from "./ahis.vue?vue&type=script&lang=js"
import style0 from "./ahis.vue?vue&type=style&index=0&id=bf2e99a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports